import Utils from '../utils/utils';
import Consts from '../utils/constants';
import '../utils/array-extension';

const DATA_TYPE = {
    NUMBER: 'number',
    STRING: 'string',
    BOOLEAN: 'boolean',
};

const LABEL = {
    REQUIRED: 'required',
    VALUE_SET: 'value_set',
    ALTERNATE: 'alternate',
    BLANK_THD_TAB: 'blank_thd_tab',
    SETTLING_THD_ADJ: 'settling_thd_adj',
    DEFAULT_DRIVER: 'default_driver',
    RECOMMENDED_DRIVER: 'recommended_driver',
};

const LABEL_CATEGORY = {
    REQUIRED: LABEL.REQUIRED,
    VALUE_SET: LABEL.REQUIRED,
    ALTERNATE: LABEL.REQUIRED,
    BLANK_THD_TAB: LABEL.BLANK_THD_TAB,
    SETTLING_THD_ADJ: LABEL.SETTLING_THD_ADJ,
    DEFAULT_DRIVER: LABEL.DEFAULT_DRIVER,
    RECOMMENDED_DRIVER: LABEL.RECOMMENDED_DRIVER,
};

const LABEL_CATEGORIES = Object.keys(LABEL_CATEGORY)
    .map((key) => LABEL_CATEGORY[key])
    .removeDuplicates();

const INVALID_CATEGORIES_EXIST = (validation) => {
    let invalid = false,
        invalidCategories = Object.keys(validation);
    for (let i = 0; i < invalidCategories.length; i++) {
        if (LABEL_CATEGORIES.includes(invalidCategories[i])) {
            invalid = true;
            break;
        }
    }

    return invalid;
};

const REQUIRED = (key, metadata, partItem) => {
    let valid = false,
        inValue = partItem[key];

    if (typeof inValue !== Consts.UNDEFINED) {
        switch (metadata.dataType) {
            case DATA_TYPE.STRING:
                if (typeof inValue === DATA_TYPE.STRING && inValue.trim() !== '') valid = true;
                break;
            case DATA_TYPE.NUMBER:
                if (typeof inValue === DATA_TYPE.NUMBER) valid = true;
                break;
            case DATA_TYPE.BOOLEAN:
                if (Utils.isBoolean(inValue)) valid = true;
                break;
        }
    }

    return {
        parameter: key,
        valid: valid,
        category: LABEL.REQUIRED,
        hidePartItem: true,
        translation: `validation.required.${metadata.dataType}`,
        transArgs: { value: inValue },
        part: partItem.part,
    };
};

const VALUE_SET = (key, metadata, partItem) => {
    let requiredResult = REQUIRED(key, metadata, partItem),
        value = partItem[key];

    return {
        parameter: key,
        valid: Array.isArray(metadata.valueSet) && requiredResult.valid && metadata.valueSet.includes(value),
        category: LABEL.REQUIRED,
        hidePartItem: true,
        translation: !requiredResult.valid ? requiredResult.translation : 'validation.value_set',
        transArgs: !requiredResult.valid
            ? requiredResult.transArgs
            : { value: value, valueSet: Array.isArray(metadata.valueSet) ? metadata.valueSet.join() : [] },
        part: partItem.part,
    };
};

const CONDITIONAL_REQUIRED = (key, metadata, partItem, conditionFunc) => {
    let requiredResult = REQUIRED(key, metadata, partItem);
    return !conditionFunc(partItem) || requiredResult.valid ? { valid: true } : requiredResult;
};

const BLANK_THD_TAB = (key, metadata, partItem) => {
    let result = CONDITIONAL_REQUIRED(key, metadata, partItem, (partItem) => {
        return !partItem.blankTHDTab;
    });
    return {
        parameter: key,
        valid: result.valid,
        category: LABEL.BLANK_THD_TAB,
        hidePartItem: true,
        translation: result.translation,
        transArgs: result.transArgs,
        part: partItem.part,
    };
};

const SETTLING_THD_ADJ = (key, metadata, partItem) => {
    let result = CONDITIONAL_REQUIRED(key, metadata, partItem, (partItem) => {
        return partItem.settlingTHDadj;
    });
    return {
        parameter: key,
        valid: result.valid,
        category: LABEL.SETTLING_THD_ADJ,
        hidePartItem: true,
        translation: result.translation,
        transArgs: result.transArgs,
        part: partItem.part,
    };
};

const ALTERNATE = (key, metadata, partItem) => {
    let result = REQUIRED(key, metadata, partItem),
        properties = [key],
        values = [partItem[key]];

    if (!result.valid) {
        for (let i = 0; i < metadata.alternates.length; i++) {
            let alternate = metadata.alternates[i];
            result = REQUIRED(alternate, metadata, partItem);
            properties.push(alternate);
            values.push(partItem[alternate]);
            if (result.valid) break;
        }
    }

    return {
        parameter: key,
        valid: result.valid,
        category: LABEL.REQUIRED,
        hidePartItem: true,
        translation: 'validation.alternate',
        transArgs: { properties: properties, values: values }, //result.transArgs,
        part: partItem.part,
    };
};

const DEFAULT = (key, metadata, partItem) => {
    if (!REQUIRED(key, metadata, partItem).valid) {
        partItem[key] = metadata.default;
    }

    return {
        valid: true,
    };
};

const DEFAULT_DRIVER = (key, metadata, adc) => {
    let requiredResult = REQUIRED(key, metadata, adc),
        value = adc[key];

    return {
        parameter: key,
        category: LABEL.DEFAULT_DRIVER,
        valid: requiredResult.valid && adc.recommendedDrivers.includes(value),
        hidePartItem: false,
        translation: !requiredResult.valid ? requiredResult.translation : 'validation.default_driver.item',
        transArgs: !requiredResult.valid
            ? requiredResult.transArgs
            : { value: value, adc: adc.part, drivers: adc.recommendedDrivers.join() },
        part: adc.part,
    };
};

const RECOMMENDED_DRIVERS = (key, metadata, adc) => {
    let invalidDrivers = [],
        value = adc[key];

    value.forEach((driver) => {
        if (!metadata.driverOptions.includes(driver)) {
            invalidDrivers.push(driver);
        }
    });

    return {
        parameter: key,
        category: LABEL.RECOMMENDED_DRIVER,
        valid: !invalidDrivers.length,
        hidePartItem: false,
        translation: 'validation.recommended_driver.item',
        transArgs: { invalidDrivers: invalidDrivers.join() },
        part: adc.part,
    };
};

const VALIDATION = {
    REQUIRED: REQUIRED,
    DEFAULT: DEFAULT,
    VALUE_SET: VALUE_SET,
    BLANK_THD_TAB: BLANK_THD_TAB,
    SETTLING_THD_ADJ: SETTLING_THD_ADJ,
    ALTERNATE: ALTERNATE,
    DEFAULT_DRIVER: DEFAULT_DRIVER,
    RECOMMENDED_DRIVERS: RECOMMENDED_DRIVERS,
};

export {
    VALIDATION,
    DATA_TYPE,
    LABEL,
    LABEL_CATEGORIES,
    INVALID_CATEGORIES_EXIST,
    /*FOR TESTING = */ REQUIRED,
    VALUE_SET,
    CONDITIONAL_REQUIRED,
    BLANK_THD_TAB,
    SETTLING_THD_ADJ,
    ALTERNATE,
    DEFAULT,
    DEFAULT_DRIVER,
    RECOMMENDED_DRIVERS,
};
